import ApiClient from './ApiClient';

class VotingClient {
  constructor(authToken, eventId) {
    this.apiClient = new ApiClient();
    this.gatewayUri = 'api/v1';
    this.latestVersion = 'v1';
    this.baseUri = process.env.VUE_APP_HACKATHON_SERVICE_URI;
    this.eventId = eventId;
    this.headers = {
      Authorization: `Bearer ${authToken}`,
    };
    this.params = {};
  }

  getVotes() {
    return this.apiClient.get(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/votes`, this.params, this.headers)
      .then((response) => response.data);
  }

  submitVote(voteInformation) {
    const dataBody = {
      team: {
        id: voteInformation.teamId,
      },
      awesomeness: voteInformation.awesomeness,
      innovation: voteInformation.innovation,
      completeness: voteInformation.completeness,
      utility: voteInformation.utility,
      difficulty: voteInformation.difficulty,
    };
    return this.apiClient.post(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/votes`, dataBody, this.headers)
      .then((response) => response.data);
  }

  updateVote(voteInformation) {
    const dataBody = {
      team: {
        id: voteInformation.teamId,
      },
      awesomeness: voteInformation.awesomeness,
      innovation: voteInformation.innovation,
      completeness: voteInformation.completeness,
      utility: voteInformation.utility,
      difficulty: voteInformation.difficulty,
    };
    return this.apiClient.put(`${this.baseUri}${this.gatewayUri}/events/${this.eventId}/votes/${voteInformation.voteId}`, dataBody, this.headers)
      .then((response) => response.data);
  }
}
export default VotingClient;
